const guestRoutes = {
    home: "/",
    login: "/",
    register: "/register",
    forgotPassword: "/forgot-password",
    emailVerify: "/email-verify",
    notfound: "*"
}

export default guestRoutes;